import { render } from "./StatisticIssuanceTime.vue?vue&type=template&id=562f1f7a&ts=true"
import script from "./StatisticIssuanceTime.vue?vue&type=script&lang=ts"
export * from "./StatisticIssuanceTime.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__